







import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  methods: {
    emitVisibilityChange(isVisible: boolean) {
      this.$emit('visibility-change', isVisible)
    }
  }
})
